module.exports = __webpack_public_path__ + "static/media/fi.1b298415.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fi.svg
// module id = 822
// module chunks = 0